<template>
  <div class="order">
    <search
      :statusList="statusList"
      :secondStatus="true"
      :secondClaimStatus="'2'"
      :recordsSearchObj="recordsSearchObj"
      :carTypeList="carTypeList"
      @handleSearch="handleSearch"
    />
    <div class="table-container">
      <div class="table-btn">
        <!--  :loading="btnLoading" -->
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport(1)"
          >成本价维护导出</el-button
        >
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport(2)"
          >导出</el-button
        >
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport(3)"
          >三包索赔单导出</el-button
        >
        <el-button
          type="text"
          icon="el-icon-printer"
          @click="handlePrint()"
          >三包索赔单打印</el-button
        >
        <el-button
          type="text"
          icon="el-icon-folder-checked"
          @click="handleBatchConfirm()"
          >批量确认</el-button
        >
        <el-button
          type="text"
          icon="el-icon-folder-checked"
          @click="handleSupplierConfirm()"
          >供应商确认</el-button
        >
      </div>
      <!-- v-loading="loading" -->
      <el-table
        :data="tableData"
        row-key="claimStatementId"
        highlight-current-row
        border
        stripe
        @filter-change="filterChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :selectable="
            (row) => {
              return row.secondClaimStatus === 1 && row.status !== 13;
            }
          "
          width="40"
          align="center"
        >
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="claimType"
          label="索赔类型"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.claimType === 1 ? '质量整改' : '整车索赔' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="claimStatementNum"
          label="索赔单号"
          :min-width="$getColumnWidth('claimStatementNum', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerAccountNum"
          label="客户账号"
          :min-width="$getColumnWidth('customerAccountNum', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          :min-width="$getColumnWidth('customerName', tableData)"
        >
        </el-table-column>

        <el-table-column
          prop="customerCountry"
          label="国家"
          min-width="120"
          show-overflow-tooltip
          align="center"
          column-key="customerCountry"
          :filters="this.countryList"
          :filter-method="filterHandler"
        >
          <template slot-scope="scope">
            <p>{{ getCountry(scope.row.customerCountry) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="carBrand"
          label="品牌"
          :min-width="$getColumnWidth('carBrand', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="carModel"
          label="车型"
          :min-width="$getColumnWidth('carModel', tableData)"
          align="center"
          column-key="carModel"
          :filters="this.carTypeList"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column
          prop="vin"
          label="VIN"
          :min-width="$getColumnWidth('vin', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="faultPartNameZh"
          label="主因故障件名称"
          :min-width="$getColumnWidth('faultPartNameZh', tableData)"
        >
        </el-table-column>
        <el-table-column
          prop="faultPartNumber"
          label="主因故障件代码"
          :min-width="$getColumnWidth('faultPartNumber', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="申请时间"
          :min-width="$getColumnWidth('createTime', tableData)"
          align="center"
        >
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="auditResultDisplay"-->
<!--          label="状态"-->
<!--          :min-width="$getColumnWidth('auditResultDisplay', tableData)"-->
<!--          align="center"-->
<!--        >-->
<!--        </el-table-column>-->
        <el-table-column
          prop="secondClaimStatus"
          label="二赔状态"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.secondClaimStatus == 1 ? "待确认（金额）" : "" }}
            {{ scope.row.secondClaimStatus == 2 ? "已确认" : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="rejectNum"
          label="驳回次数"
          :min-width="$getColumnWidth('rejectNum', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditPassTime"
          label="正审时间"
          :min-width="$getColumnWidth('auditPassTime', tableData)"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="determineResponsibilityTime"
          label="判责时间"
          :min-width="$getColumnWidth('determineResponsibilityTime', tableData)"
          align="center"
        >
        </el-table-column> -->
        <el-table-column
          prop="confirmResponsibilityTime"
          label="责任确定时间"
          :min-width="$getColumnWidth('confirmResponsibilityTime', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="settlementTime"
          label="结算时间"
          :min-width="$getColumnWidth('settlementTime', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in responsibilityPartListMaxLength"
          :key="index"
          :label="`责任方${numberToChinese(item)}`"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <el-table-column
            label=""
            min-width="160"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index]
                      .responsibilitySupplier ||
                    scope.row.responsibilityPartList[index]
                      .responsibilityDepartment
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label=""
            min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? `${scope.row.responsibilityPartList[index].responsibilityRatio}%`
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label=""
            min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index].secondDamages
                    ? `¥${scope.row.responsibilityPartList[index].secondDamages}`
                    : "无"
                  : "无"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="初赔金额"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList.length > 0
              "
            >
              ¥{{
                scope.row.currency === 1
                  ? (scope.row.claimTotalCost * exchangeRate).toFixed(2)
                  : scope.row.claimTotalCost
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="二次索赔金额"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList.length > 0
              "
            >
              ¥{{ getDamages(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="金额差"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList.length > 0
              "
            >
              ¥{{
                (
                  (scope.row.currency === 1
                    ? scope.row.claimTotalCost * exchangeRate
                    : scope.row.claimTotalCost
                  ).toFixed(2) - getDamages(scope.row)
                ).toFixed(2)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="220px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="toDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.status !== 13"
              size="mini"
              type="text"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="
                scope.row.secondClaimStatus === 1 && scope.row.status !== 13
              "
              size="mini"
              type="text"
              @click="handleFill(scope.row, scope.$index)"
              >确认金额</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <three-pack-export-dialog ref="threePackExportDialogRef" />
  </div>
</template>
<script>
import {
  fillSecondList,
  secondConfirmClimantExport,
  costPriceMaintenanceExport,
  batchConfirmAmount,
  threeGuaranteesPrintApi,
} from "@/api/seek";
import search from "@/components/claimantSearch";
import { getNations } from "@/util/getNation";
import { getSession, setStorage } from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";
import { getDictItem, getDictValue } from "@/util/dict";
import { numberToChinese } from "@/util/index";
import ThreePackExportDialog from "./components/threePackExportDialog.vue";

export default {
  components: {
    search,
    ThreePackExportDialog,
  },
  data() {
    const { data, pageNum, pageSize } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route?.query?.searchObj)
      : {};
    return {
      statusList: [
        { label: "全部", value: "11,12,13,14" },
        { label: "待结算", value: "11" },
        { label: "已结算", value: "12" },
        { label: "已取消", value: "13" },
        { label: "已撤回", value: "14" },
      ],
      searchInfo: {
        secondClaimStatus: "2",
      },
      // loading: false,
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      total: 0,
      // btnLoading: false,
      recordsSearchObj: data,
      countryList: [],
      searchData: {},
      carTypeList: [],
      responsibilityPartListMaxLength: 0, // 责任方列表最大长度
      multipleSelection: [], // 表格选中数据
      exchangeRate: 1, // 汇率
    };
  },
  async mounted() {
    this.searchInfo = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.searchInfo;
    delete this.searchInfo.auditPassTime;
    delete this.searchInfo.determineResponsibilityTime;
    delete this.searchInfo.settlementTime;
    delete this.searchInfo.happenTime;
    Object.values(getSession("nationList")).map((item) => {
      if (item.id != 0) {
        this.countryList.push({ text: item.name, value: item.id });
      }
    });
    await this.getExchangeRate();
    this.getList();
    // 获取车型
    const carTypeList = await getDictItem("carType");
    carTypeList.map((item) => {
      this.carTypeList.push({ text: item.value, value: item.code });
    });
  },
  methods: {
    numberToChinese,
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 获取二赔总金额
    getDamages({ responsibilityPartList }) {
      var sum = 0;
      responsibilityPartList.map((item) => {
        sum += item.secondDamages;
      });
      return sum.toFixed(2);
    },
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch(data) {
      this.searchData = JSON.parse(JSON.stringify(data));
      let obj = data;
      this.searchInfo.claimStatementNum = obj.claimStatementNum;
      this.searchInfo.status = obj.status;
      this.searchInfo.secondClaimStatus = obj.secondClaimStatus;
      this.searchInfo.customerAccountNum = obj.customerAccountNum;
      this.searchInfo.customerName = obj.customerName;
      this.searchInfo.lbjzy = obj.lbjzy;
      if (
        typeof obj.countryId === "string" ||
        typeof obj.countryId === "number"
      ) {
        this.searchInfo.countryId =
          obj.countryId && obj.countryId != "0" ? [obj.countryId] : [];
      }
      if (typeof obj.carModel === "string") {
        this.searchInfo.carModel = obj.carModel ? [obj.carModel] : [];
      }
      this.searchInfo.carBrand = obj.carBrand;
      this.searchInfo.vin = obj.vin;
      this.searchInfo.faultPartNumber = obj.faultPartNumber;
      this.searchInfo.faultPartNameZh = obj.faultPartNameZh;
      this.searchInfo.responsibilityDepartment = obj.responsibilityDepartment;
      this.searchInfo.supplierName = obj.supplierName;
      this.page = 1;
      this.pageSize = 10;
      if (data.applyDate !== "" && data.applyDate !== null) {
        this.searchInfo.createTimeStart = data.applyDate[0] + " 00:00:00";
        this.searchInfo.createTimeEnd = data.applyDate[1] + " 23:59:59";
      } else {
        this.searchInfo.createTimeStart = "";
        this.searchInfo.createTimeEnd = "";
      }
      if (data.auditPassTime !== "" && data.auditPassTime !== null) {
        this.searchInfo.auditPassTimeStart =
          data.auditPassTime[0] + " 00:00:00";
        this.searchInfo.auditPassTimeEnd = data.auditPassTime[1] + " 23:59:59";
      } else {
        this.searchInfo.auditPassTimeStart = "";
        this.searchInfo.auditPassTimeEnd = "";
      }
      if (data.confirmTime !== "" && data.confirmTime !== null) {
        this.searchInfo.confirmTimeStart = data.confirmTime[0] + " 00:00:00";
        this.searchInfo.confirmTimeEnd = data.confirmTime[1] + " 23:59:59";
      } else {
        this.searchInfo.confirmTimeStart = "";
        this.searchInfo.confirmTimeEnd = "";
      }
      if (
        data.determineResponsibilityTime !== "" &&
        data.determineResponsibilityTime !== null
      ) {
        this.searchInfo.determineResponsibilityTimeStart =
          data.determineResponsibilityTime[0] + " 00:00:00";
        this.searchInfo.determineResponsibilityTimeEnd =
          data.determineResponsibilityTime[1] + " 23:59:59";
      } else {
        this.searchInfo.determineResponsibilityTimeStart = "";
        this.searchInfo.determineResponsibilityTimeEnd = "";
      }
      if (data.settlementTime !== "" && data.settlementTime !== null) {
        this.searchInfo.settlementTimeStart =
          data.settlementTime[0] + " 00:00:00";
        this.searchInfo.settlementTimeEnd =
          data.settlementTime[1] + " 23:59:59";
      } else {
        this.searchInfo.settlementTimeStart = "";
        this.searchInfo.settlementTimeEnd = "";
      }
      if (data.happenTime !== "" && data.happenTime !== null) {
        this.searchInfo.happenTimeStart = data.happenTime[0] + " 00:00:00";
        this.searchInfo.happenTimeEnd = data.happenTime[1] + " 23:59:59";
      } else {
        this.searchInfo.happenTimeStart = "";
        this.searchInfo.happenTimeEnd = "";
      }
      this.getList();
    },
    // 记录当前列表搜索条件
    recordSearchObj() {
      this.$router.replace(
        "/secondCompensationFill?searchObj=" +
          JSON.stringify({
            data: {
              ...this.searchInfo,
              applyDate: this.searchInfo.createTimeStart
                ? [
                    this.searchInfo.createTimeStart.split(" ")[0],
                    this.searchInfo.createTimeEnd.split(" ")[0],
                  ]
                : "",
              auditPassTime: this.searchInfo.auditPassTimeStart
                ? [
                    this.searchInfo.auditPassTimeStart.split(" ")[0],
                    this.searchInfo.auditPassTimeEnd.split(" ")[0],
                  ]
                : "",
              determineResponsibilityTime: this.searchInfo
                .determineResponsibilityTimeStart
                ? [
                    this.searchInfo.determineResponsibilityTimeStart.split(
                      " "
                    )[0],
                    this.searchInfo.determineResponsibilityTimeEnd.split(
                      " "
                    )[0],
                  ]
                : "",
              settlementTime: this.searchInfo.settlementTimeStart
                ? [
                    this.searchInfo.settlementTimeStart.split(" ")[0],
                    this.searchInfo.settlementTimeEnd.split(" ")[0],
                  ]
                : "",
              happenTime: this.searchInfo.happenTimeStart
                ? [
                    this.searchInfo.happenTimeStart.split(" ")[0],
                    this.searchInfo.happenTimeEnd.split(" ")[0],
                  ]
                : "",
            },
            pageNum: this.page,
            pageSize: this.pageSize,
          })
      );
    },
    // 查看
    toDetail(data) {
      setStorage("claimantData", data);
      this.recordSearchObj();
      this.$router.push({
        path: "/claimant/secondCompensationFillDetail",
        query: { claimantId: data.claimStatementNum, operate: "查看详情" },
      });
    },
    // 责任判定
    handleFill(data, index) {
      setStorage("claimantData", data);
      this.recordSearchObj();
      this.$router.push({
        path: "/claimant/secondCompensationFillDetail",
        query: {
          claimantId: data.claimStatementNum,
          searchObj: JSON.stringify({
            data: {
              ...this.searchInfo,
            },
            page: {
              pageNum:
                (Number(this.page) - 1) * Number(this.pageSize) + index + 1,
              pageSize: 1,
            },
          }),
          enableNext: this.searchInfo.secondClaimStatus === "1" ? "1" : "0",
          operate: "确认金额",
        },
      });
    },
    // 编辑
    handleEdit(data) {
      setStorage("claimantData", data);
      this.recordSearchObj();
      this.$router.push({
        path: "/claimant/secondCompensationFillEdit",
        query: { claimantId: data.claimStatementNum, operate: "编辑金额" },
      });
    },
    // 导出
    async handleExport(type) {
      // this.btnLoading = true;
      let query = {
        ...this.searchInfo,
      };
      try {
        let res = {};
        // 成本价维护导出
        if (type === 1) {
          res = await costPriceMaintenanceExport(query);
        }
        // 索赔单导出
        if (type === 2) {
          res = await secondConfirmClimantExport(query);
        }
        // 三包索赔单导出
        if (type === 3) {
          this.$refs.threePackExportDialogRef.init();
          // this.btnLoading = false;
          return;
        }
        getDownloadFiles(res);
        if (res.fileName) {
          this.$DonMessage.success("导出成功！")
        }
      } catch (error) {}
      // this.btnLoading = false;
    },
    // 三包索赔单打印
    async handlePrint() {
      await this.$refs.threePackExportDialogRef.init("print");
    },
    // 批量确认
    async handleBatchConfirm() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$DonMessage.warning("请选择要确认的索赔单");
        return;
      }
      // this.btnLoading = true;
      try {
        const claimStatementIdList = this.multipleSelection.map((item) => {
          return item.claimStatementId;
        });
        const res = await batchConfirmAmount({
          claimStatementIdList,
        });
        if (res.status === "0") {
          this.$DonMessage.success("批量确认成功");
          this.getList();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {}
      // this.btnLoading = false;
    },
    // 供应商确认
    handleSupplierConfirm() {
      this.$refs.threePackExportDialogRef.init("supplierConfirm");
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 获取列表
    async getList() {
      // this.loading = true;
      let query = {
        data: {
          ...this.searchInfo,
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize,
        },
      };
      const res = await fillSecondList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.loading = false;
        this.responsibilityPartListMaxLength = 0;
        res.data.records.map((item) => {
          if (
            item.responsibilityPartList &&
            item.responsibilityPartList.length >
              this.responsibilityPartListMaxLength
          ) {
            this.responsibilityPartListMaxLength =
              item.responsibilityPartList.length;
          }
        });
      }
      // this.loading = false;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    // 表头筛选
    filterChange(value) {
      // 国家过滤
      if (value.customerCountry) {
        if (value.customerCountry.length === 0) {
          this.searchInfo.countryId = this.searchData.countryId || [];
        } else {
          this.searchInfo.countryId = value.customerCountry;
        }
      }
      // 车型过滤
      if (value.carModel) {
        if (value.carModel.length === 0) {
          this.searchInfo.carModel = this.searchData.carModel || [];
        } else {
          this.searchInfo.carModel = value.carModel;
        }
      }
      this.getList();
    },
    // 表格选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
// .table-container {
//   padding: 0 7px 0 23px;
// }
.responsibilityPartListTip {
  display: flex;
  text-align: center;
  padding: 18px 20px;
  .item {
    width: 120px;
  }
  .item2 {
    width: 180px;
  }
}
</style>
